var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v_main_view"},[(_vm.$global.adminUser.type == 2)?_c('main-view-store'):_vm._e(),(_vm.$global.adminUser.type >= 4)?_c('main-view-admin'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }